"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _promise = _interopRequireDefault(require("@leverege/promise"));
var _deepmerge = _interopRequireDefault(require("deepmerge"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class MergeBackend {
  constructor(services, options) {
    this.backends = [];
    this.type = MergeBackend.type;
    this.init(services, options);
  }
  init(services, options = {}, i18nextOptions) {
    this.services = services;
    this.options = options;
    this.options.backends?.forEach((b, i) => {
      this.backends[i] = this.backends[i] || createClassOnDemand(b);
      this.backends[i].init(services, this.options.backendOptions && this.options.backendOptions[i] || {}, i18nextOptions);
    });
  }
  read(language, namespace, callback) {
    const lengthCheckAmount = this.options.handleEmptyResourcesAsFailed ? 0 : -1;
    _promise.default.map(this.backends, backend => {
      return new Promise((resolve, reject) => {
        if (backend.read) {
          backend.read(language, namespace, (err, data) => {
            if (!err && data && Object.keys(data).length > lengthCheckAmount) {
              resolve(data);
            } else {
              reject(err || new Error('Backend failed to load data'));
            }
          });
        } else {
          reject(new Error('Backend has no `read` function'));
        }
      });
    }, {
      handleReject: true
    }).then(results => {
      const successes = results.filter(r => !(r instanceof Error));
      if (successes.length > 0) {
        const merged = successes.reduce((prev, curr) => {
          return (0, _deepmerge.default)(curr, prev);
        }, {});
        callback(null, merged);
      } else {
        callback(new Error('No i18N backends loaded results'));
      }
    });
  }
  create(languages, namespace, key, fallbackValue) {
    this.backends.forEach(b => {
      if (b.create) b.create(languages, namespace, key, fallbackValue);
    });
  }
}
exports.default = MergeBackend;
function createClassOnDemand(ClassOrObject) {
  if (!ClassOrObject) return null;
  if (typeof ClassOrObject === 'function') return new ClassOrObject();
  return ClassOrObject;
}
MergeBackend.type = 'backend';